<template>
  <div class="buttons-container">
    <div class="buttons">
      <div
        @click="requestSearchScreen"
        :style="{ backgroundColor: searchBackgroundColor }"
      >
        <img :src="searchIcon" />
      </div>

      <div @click="requestShopListScreen">
        <img :src="menu" />
      </div>
      <div @click="$emit('userLocationClicked')">
        <img :src="locationArrow" />
      </div>
    </div>

    <div class="buttons">
      <div @click="zoomIn">
        <span>+</span>
      </div>
      <div @click="zoomOut">
        <span>&minus;</span>
      </div>
    </div>
  </div>
</template>

<script>
import LocationArrow from "../assets/location-arrow.svg"
import Menu from "../assets/menu.svg"
import IconSearch from "../assets/icon-search.svg"
import IconSearchInverted from "../assets/icon-search-inverted.svg"
import { mapActions, mapGetters } from "vuex"
import { DisplayMode } from "../store/stores"

export default {
  data() {
    return {
      locationArrow: LocationArrow,
      menu: Menu,
      iconSearch: IconSearch,
      iconSearchInverted: IconSearchInverted
    }
  },

  computed: {
    searchIcon() {
      if (this.displayMode === DisplayMode.normal) {
        return this.iconSearch
      }

      return this.iconSearchInverted
    },

    searchBackgroundColor() {
      if (this.displayMode == DisplayMode.normal) {
        return "#fff"
      }

      return "#f05353"
    },

    ...mapGetters("stores", ["displayMode"])
  },

  methods: {
    ...mapActions("map", ["zoomIn", "zoomOut"]),
    ...mapActions("nav", ["requestShopListScreen", "requestSearchScreen"])
  }
}
</script>

<style>
.buttons-container {
  position: fixed;
  right: -8px;
  bottom: 50%;
  margin-bottom: -205px;
}

.buttons {
  pointer-events: all;
  align-self: flex-end;
  margin-right: 1rem;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  width: 3rem;
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.161);
  overflow: hidden;
}

.buttons > div {
  height: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #f05353;
  font-size: 175%;
  line-height: 0;
}

.buttons > div > span {
  margin-bottom: 5px;
}

.buttons > div:not(:last-child) {
  border-bottom: 1px solid #dedede;
}

@media screen and (width: 375px) {
  .buttons-container {
    bottom: 120px;
    margin-bottom: 0;
  }
}

@media screen and (max-width: 374px) {
  .buttons-container {
    bottom: 100px;
    margin-bottom: 0;
  }
}
</style>
